module.exports = __webpack_public_path__ + "static/media/financeicon.fe234f77.svg";